import React from 'react';
import { cn } from '../../utils/cn';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  required?: boolean; // if true, shows * in red
  startEnhancer?: React.ReactNode;
  endEnhancer?: React.ReactNode;
  error?: string;
  inputClassName?: string;
  wrapperClassName?: string;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  (
    {
      className,
      type,
      label,
      required = false,
      startEnhancer,
      endEnhancer,
      error,
      inputClassName,
      wrapperClassName,
      ...props
    },
    ref
  ) => {
    return (
      <div className={cn('flex flex-col', wrapperClassName || className)}>
        {label && (
          <label className="block text-base font-medium mb-2">
            {label}
            {required && <span className="text-[#F03434] ml-1">*</span>}
          </label>
        )}
        <div className="relative">
          {startEnhancer && (
            <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
              {startEnhancer}
            </div>
          )}

          {/* show border red when error */}
          <input
            type={type}
            className={cn(
              'flex h-10 w-full rounded-md border border-muted bg-foreground px-3 py-2 text-base text-text2 ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted',
              'focus:outline-none focus:border-accent',
              'disabled:bg-gray-100 disabled:text-gray-500 disabled:cursor-not-allowed',
              error && 'border-red-500',
              startEnhancer && 'pl-10',
              endEnhancer && 'pr-10',
              inputClassName || className
            )}
            ref={ref}
            {...props}
          />
          {endEnhancer && (
            <div className="absolute right-3 top-2/4 transform -translate-y-1/2">
              {endEnhancer}
            </div>
          )}
        </div>
        <div className="min-h-[1rem] bg-transparent mt-0.5">
          {error && <p className="text-red-500 text-sm leading-tight">{error}</p>}
        </div>
      </div>
    );
  }
);

Input.displayName = 'Input';

export { Input };
